export type NSParam = string | string[];

export const fallbackLng = "nl";
export const languages = [fallbackLng, "en"];
export const defaultNS: NSParam = ["common", "validations", "datetime"];

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "em", "p"],
    },
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  };
}
